import ssa_113_1 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_1.pdf";
import ssa_113_2 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_2.pdf";
import ssa_113_3 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_3.pdf";
import ssa_113_4 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_4.pdf";
import ssa_113_5 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_5.pdf";
import ssa_113_6 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_6.pdf";
import ssa_113_7 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_7.pdf";
import ssa_113_8 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_8.pdf";
import ssa_113_9 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_9.pdf";
import ssa_113_10 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_10.pdf";
import ssa_113_11 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_11.pdf";
import ssa_113_12 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_12.pdf";
import ssa_113_13 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_13.pdf";
import ssa_113_14 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_14.pdf";
import ssa_113_15 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_15.pdf";
import ssa_113_16 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_16.pdf";
import ssa_113_17 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_17.pdf";
import ssa_113_18 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_18.pdf";
import ssa_113_19 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_19.pdf";
// import ssa_113_20 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_20.pdf";
// import ssa_113_21 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_21.pdf";
// import ssa_113_22 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_22.pdf";
// import ssa_113_23 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_23.pdf";
// import ssa_113_24 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_24.pdf";
// import ssa_113_25 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_25.pdf";
// import ssa_113_26 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_26.pdf";
// import ssa_113_27 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_27.pdf";
// import ssa_113_28 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_28.pdf";
// import ssa_113_29 from "@/assets/studentAwardsRouter/studentAwardsFile/113/ssa_113_29.pdf";
var awardsPath_113 = [
  ssa_113_19,
  ssa_113_18,
  ssa_113_17,
  ssa_113_16,
  ssa_113_15,
  ssa_113_1,
  ssa_113_2,
  ssa_113_3,
  ssa_113_4,
  ssa_113_5,
  ssa_113_6,
  ssa_113_7,
  ssa_113_8,
  ssa_113_9,
  ssa_113_10,
  ssa_113_11,
  ssa_113_12,
  ssa_113_13,
  ssa_113_14,
  // ssa_113_20,
  // ssa_113_21,
  // ssa_113_22,
  // ssa_113_23,
  // ssa_113_24,
  // ssa_113_25,
  // ssa_113_26,
//   ssa_113_27,
//   ssa_113_28,
//   ssa_113_29,
];
export { awardsPath_113 };
